import { getRequest, postRequest, putRequest, listRequest, putRequestNoSessionID, postRequestNoSessionID } from "./rest"
import {IPractice} from "../Practices/Entities/IPractice"
import {PracticeListResponse} from "./Responses/PracticeResponses"

class PracticeAPI {

  async addPractice(practice:IPractice){
    await postRequestNoSessionID<any>("/practices",practice);
  }

  async updatePractice(practice:IPractice) {
    await putRequestNoSessionID<any>("/practices/"+practice.id,practice);
  }

  async getPractice(practiceId:number) {
    return await getRequest<any>("/practices/"+practiceId);
  }

  async getCurrentPractice() {
    return await getRequest<any>("/practices/current");
  }

  async getPractices(offset:number, limit:number, searchTerm: string) {
    const response: any = await listRequest<any>("/practices",
    {
      offset,
      limit,
      searchTerm
    });

    let contentRange = response.headers['content-range'];
    let totalLength = Number(contentRange?.substring(contentRange.indexOf('/')+1));
    const practiceListResponse:PracticeListResponse = {items:response.data,totalLength};
    return practiceListResponse;
  }
}

const practiceAPI = new PracticeAPI();
export default practiceAPI;
